// src/layouts/Header.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';

function Header({ isEnglish }) {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [isFeatureMenuOpen, setIsFeatureMenuOpen] = useState(false);
  // featureMenuRef は今回使用しませんが、将来的なクリック外検知のために残しておきます
  const featureMenuRef = useRef(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // スマホでメニューを開いたままPC幅にした場合などのリセット
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleFeatureMenu = (e) => {
    e.preventDefault(); // リンク遷移を防ぐ
    setIsFeatureMenuOpen((prev) => !prev);
  };

  // ▼▼▼ 表示ロジック ▼▼▼
  useEffect(() => {
    // トップページかどうか
    const isHomePage = pathname === '/' || pathname === '/en' || pathname === '/en/';

    // トップページ以外（/booking, /faqなど）なら、無条件で表示ON
    if (!isHomePage) {
      setShowHeader(true);
    } else {
      // トップページかつスクロールが上部の場合は初期状態OFF
      // ただし、既にスクロールされている状態でリロードした場合を考慮
      if (window.scrollY > 100) {
        setShowHeader(true);
      } else {
        setShowHeader(false);
      }
    }

    const handleScroll = () => {
      // トップページの場合のみ、スクロールで出し入れする
      if (isHomePage) {
        if (window.scrollY > 100) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname]);

  return (
    // showHeaderがtrueなら visible クラスが付く
    <header className={`header ${showHeader ? 'visible' : 'hidden'}`}>
      <div className="logo-container">
        <a href={isEnglish ? '/en' : '/'}>
          {/* ロゴ画像のパスは環境に合わせて調整してください */}
          <img src="/images/logo.png" alt="Akebono Logo" className="logo-image" />
        </a>
      </div>

      <button className="hamburger" onClick={toggleMenu} aria-label="Menu">
        ☰
      </button>

      <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <ul className="nav-list">

          {/* 5つの魅力（ドロップダウン） */}
          <li className="has-submenu" ref={featureMenuRef}>
            <span onClick={toggleFeatureMenu} style={{ cursor: 'pointer' }}>
              {isEnglish ? 'Five Features' : '5つの魅力'} ▿
            </span>
            {isFeatureMenuOpen && (
              <ul className="submenu open">
                <li><a href={isEnglish ? '/en/features/garden' : '/features/garden'} onClick={toggleMenu}>{isEnglish ? 'Garden Retreat' : '庭園文化と静寂の宿'}</a></li>
                <li><a href={isEnglish ? '/en/features/craft' : '/features/craft'} onClick={toggleMenu}>{isEnglish ? 'Living with Crafts' : '伝統工芸が佇む空間'}</a></li>
                <li><a href={isEnglish ? '/en/features/machiya' : '/features/machiya'} onClick={toggleMenu}>{isEnglish ? '150-Year Machiya' : '歴史ある町家'}</a></li>
                <li><a href={isEnglish ? '/en/features/renovation' : '/features/renovation'} onClick={toggleMenu}>{isEnglish ? 'Comfort & History' : '快適性と風情'}</a></li>
                <li><a href={isEnglish ? '/en/features/primelocation' : '/features/primelocation'} onClick={toggleMenu}>{isEnglish ? 'Prime Location' : '金沢観光の拠点'}</a></li>
              </ul>
            )}
          </li>

          <li><a href={isEnglish ? '/en#facility' : '/#facility'} onClick={toggleMenu}>{isEnglish ? 'Facility' : '施設紹介'}</a></li>
          <li><a href={isEnglish ? '/en/specialoffer' : '/special-offer'} onClick={toggleMenu}>{isEnglish ? 'Special Offer' : '特別な体験'}</a></li>
          <li>
            <a
              href={isEnglish ? '/en/zen-hondamachi' : '/zen-hondamachi'}
              onClick={toggleMenu}
            >
              {isEnglish ? 'Zen & Honda-machi' : '禅のまち 本多町'}
            </a>
          </li>
          <li><a href={isEnglish ? '/en#how-to-stay' : '/#how-to-stay'} onClick={toggleMenu}>{isEnglish ? 'How to Stay' : 'ご利用の流れ'}</a></li>
          <li><a href={isEnglish ? '/en#floor-map' : '/#floor-map'} onClick={toggleMenu}>{isEnglish ? 'Floor Map' : 'フロアマップ'}</a></li>
          <li><a href={isEnglish ? '/en#access' : '/#access'} onClick={toggleMenu}>{isEnglish ? 'Access' : 'アクセス'}</a></li>

          {/* ▼▼▼ 追加: FAQへのリンク ▼▼▼ */}
          <li>
            <a href={isEnglish ? '/en/faq' : '/faq'} onClick={toggleMenu}>
              {isEnglish ? 'FAQ' : 'よくある質問'}
            </a>
          </li>

          <li>
            <a href={isEnglish ? '/en/contact' : '/contact'} onClick={toggleMenu}>
              {isEnglish ? 'Contact' : 'お問い合わせ'}
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;